import styled from "styled-components/macro";

export const DividerGradient = styled.img`
  margin-left: auto;
  margin-right: auto;
  margin-top: -10px;
  /* margin-top: -70px; */
  margin-bottom: 10px;
  width: min(30%, 250px);
  min-width: 175px;
  display: block;
`;

export const DividerDiv = styled.div`
  width: 100%;
`;
